import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0 cursor-pointer bg-success px-4\"><div class=\"card-title\"><div class=\"d-flex align-items-center position-relative my-1\"><span class=\"card-label fw-bolder fs-3 mb-1 text-light\">Course Categories</span></div></div><div class=\"card-toolbar\"></div></div>", 1)
const _hoisted_3 = { class: "card mb-5 mb-xl-10 m-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        "data-kt-drawer-toggle": "true",
        "data-kt-drawer-target": "#kt_drawer_add_category",
        id: "kt_drawer_add_category_button",
        class: "btn btn-primary p-2"
      }, [
        /*#__PURE__*/_createTextVNode(" Add Category "),
        /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" })
      ])
    ])
  ])
], -1)
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-6" }
const _hoisted_7 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt text-light" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-light" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_AddCourseTypeDrawer = _resolveComponent("AddCourseTypeDrawer")!
  const _component_EditCourseDrawer = _resolveComponent("EditCourseDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(), _createElementBlock("div", {
          key: _ctx.componentKey,
          id: "trainee_data",
          class: "collapse show"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Datatable, {
                  "table-data": _ctx.tableData,
                  "table-header": _ctx.tableHeader,
                  "enable-items-per-page-dropdown": true
                }, {
                  "cell-category_type": _withCtx(({ row: category }) => [
                    _createTextVNode(_toDisplayString(category.category_name), 1)
                  ]),
                  "cell-actions": _withCtx(({ row: category }) => [
                    _createElementVNode("button", {
                      "data-kt-drawer-toggle": "true",
                      "data-kt-drawer-target": "#kt_drawer_edit_category",
                      id: "kt_drawer_edit_category_button",
                      onClick: ($event: any) => (_ctx.editCategory(category)),
                      class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                    }, _hoisted_10, 8, _hoisted_8),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.DeleteCategory(category.id)),
                      class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                    }, _hoisted_13, 8, _hoisted_11)
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header"])
              ])
            ])
          ])
        ]))
      ])
    ]),
    _createVNode(_component_AddCourseTypeDrawer),
    _createVNode(_component_EditCourseDrawer)
  ], 64))
}